import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { useCourtBookingStore } from "../../stores/StoreContext";

type props = {};

export const SelectedCourt: React.FC<props> = () => {
  const courtBookingStore = useCourtBookingStore();
  return (
    <div
      style={{
        backgroundColor: Colors.green,
        paddingTop: 3,
        paddingBottom: 3,
        paddingLeft: 8,
        paddingRight: 8,
        display: "inline-block",
        borderRadius: 8,
        marginTop: 10,
      }}
    >
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 10,
          color: "white",
          marginBottom: 1,
        }}
        value={courtBookingStore.selectedCourt?.title}
      />
    </div>
  );
};
